import axios from "axios";

import { getCurrentCounsellorPortal } from "../components/CounsellorPortal/portalConfig";

const getStoredCounsellorUser = () => {
  const { storageKey } = getCurrentCounsellorPortal();
  try {
    const storedCounsellorUser = localStorage.getItem(storageKey);
    return storedCounsellorUser ? JSON.parse(storedCounsellorUser) : null;
  } catch {
    localStorage.removeItem(storageKey);
    return null;
  }
};

const counsellorHttpCommon = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

counsellorHttpCommon.interceptors.request.use(
  (config) => {
    const token = config.skipAuth ? null : getStoredCounsellorUser()?.token;

    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

counsellorHttpCommon.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const portal = getCurrentCounsellorPortal();
      localStorage.removeItem(portal.storageKey);
      window.location.href = `${portal.basePath}/login`;
    }

    return Promise.reject(error);
  }
);

export default counsellorHttpCommon;
